import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import withRouter from '../../../lib/router/withRouter';
import CsInquiryDetailWrap from '../../../views/cs/inquiry/detail/CsInquiryDetailWrap';
import { csInquiryActions } from '../../../store/modules/cs/inquiry';
import { LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import { asyncSimpleModal } from '../../../lib/common';

class CsInquiryDetailContainer extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  initiate = (inquiryId) => {
    const { getCsInquiryDetail } = this.props;

    getCsInquiryDetail({
      inquiryId,
      usersOtherInquiry: {
        pagination: LIST_PAGINATION_MODEL,
      },
    });
  };

  /**
   *  유저의 다른 문의 내역 조회하기 (페이지네이션)
   */
  getUsersOtherInquiryList = (data) => {
    const { csInquiryDetail, getCsUsersOtherInquiryList } = this.props;
    const { userId, usersOtherInquiry } = csInquiryDetail.userInfo;
    const { inquiryId } = csInquiryDetail.inquiryInfo;
    const { pagination } = usersOtherInquiry;

    getCsUsersOtherInquiryList({
      userId,
      inquiryId,
      pagination,
      ...data,
    });
  };

  /**
   *  1:1 문의 답변 작성하기
   */
  onReply = () => {
    const { form, csInquiryDetail, replyCsInquiryDetail } = this.props;
    form.validateFieldsAndScroll({ scroll: { offsetBottom: 100 } }, async (err) => {
      if (err) return;

      const { inquiryInfo } = csInquiryDetail;
      const { inquiryId, answer, memo, isResponse } = inquiryInfo;

      /**
       *  수정을 하는 경우에는 경고메시지 보여주기
       */
      if (isResponse) {
        const confirmResult = await asyncSimpleModal({
          type: 'confirm',
          title: '문의 답변 수정',
          message: '문의 답변을 수정하면, 이전의 답변 내용과 작성자 정보가 없어집니다.\n 그래도 진행을 하시겠습니까?',
        });

        if (!confirmResult) return;
      }

      replyCsInquiryDetail({
        inquiryId,
        answer,
        memo,
        isUpdate: isResponse,
      });
    });
  };

  render() {
    const { csInquiryDetail, form, setData } = this.props;

    return (
      <CsInquiryDetailWrap
        form={form}
        setData={setData}
        csInquiryDetail={csInquiryDetail}
        getUsersOtherInquiryList={this.getUsersOtherInquiryList}
        onReply={this.onReply}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    csInquiryDetail: state.csInquiry.csInquiryDetail,
  };
};

const mapDispatchToProps = {
  setData: csInquiryActions.setData,
  getCsInquiryDetail: csInquiryActions.getCsInquiryDetail,
  getCsUsersOtherInquiryList: csInquiryActions.getCsUsersOtherInquiryList,
  replyCsInquiryDetail: csInquiryActions.replyCsInquiryDetail,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(withRouter(CsInquiryDetailContainer)));
